//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('business', {
//        templateUrl: 'views/components/views/business/business.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'businessService', function ($stateParams, stateService, businessService) {
//            const vm = this;
//            let businessId = $stateParams.business_id;

//            vm.model = {
//                businessId: businessId,
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await businessService.getEdit({ business_id: businessId }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                businessService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            };
//		}]
//	});
//})();
